import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Membres from "@/pages/Membres";
import Benevoles from "@/pages/Benevoles";
import Salaries from "@/pages/Salaries";
import Comptabilite from "@/pages/Comptabilite";
import Bulletins from "@/pages/Bulletins";
import OrdresMission from "@/pages/OrdresMission";
import Attestations from "@/pages/Attestations";
import RecusDon from "@/pages/RecusDon";
import CartesMembres from "@/pages/CartesMembres";
import Bilan from "@/pages/Bilan";
import Evenements from "@/pages/Evenements";
import Partenaires from "@/pages/Partenaires";
import Parametres from "@/pages/Parametres";
import Inscription from "@/pages/Inscription";
import InscriptionBenevole from "@/pages/InscriptionBenevole";
import Forum from "@/pages/Forum";
import EspaceMembre from "@/pages/EspaceMembre";
import { api } from "@/lib/api";

function RequireAuth({ children }) {
  const token = localStorage.getItem("aij_token");
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  useEffect(() => {
    api.get("/").catch(() => {});
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/inscription" element={<Inscription />} />
          <Route path="/inscription-benevole" element={<InscriptionBenevole />} />
          <Route path="/espace-membre/:token" element={<EspaceMembre />} />
          <Route
            path="/app"
            element={
              <RequireAuth>
                <Layout />
              </RequireAuth>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="membres" element={<Membres />} />
            <Route path="benevoles" element={<Benevoles />} />
            <Route path="salaries" element={<Salaries />} />
            <Route path="partenaires" element={<Partenaires />} />
            <Route path="evenements" element={<Evenements />} />
            <Route path="comptabilite" element={<Comptabilite />} />
            <Route path="bilan" element={<Bilan />} />
            <Route path="bulletins" element={<Bulletins />} />
            <Route path="ordres-mission" element={<OrdresMission />} />
            <Route path="attestations" element={<Attestations />} />
            <Route path="recus-don" element={<RecusDon />} />
            <Route path="cartes-membres" element={<CartesMembres />} />
            <Route path="forum" element={<Forum />} />
            <Route path="parametres" element={<Parametres />} />
          </Route>
          <Route path="/" element={<Navigate to="/app" replace />} />
          <Route path="*" element={<Navigate to="/app" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
